<template>
    <div>
        <div v-if="($safe(detail,'Results') || []).length == 0" class="text-center">
            Henüz bir işlem yapılmamış.
        </div>
        <div v-else class="table-responsive mb-0">
            <table class="table table-sm table-bordered">
                <tbody>
                    <tr class="font-weight-bolder bg-light">
                        <td class="w-15">İşlem Tarihi</td>
                        <td class="w-10">Miktar</td>
                        <td>Durum</td>
                    </tr>
                    <tr v-for="(r,ii) in $safe(detail,'Results')" :key="ii">
                        <td class="text-nowrap">{{ $safe(r,'CalculationDateTimeStr') }}</td>
                        <td class="text-nowrap">{{ $safe(r,'AmountStr') }}</td>
                        <td>
                            <ul class="list-group">
                                <li class="list-group-item px-50 py-25 text-danger" v-for="(e,iii) in r.Errors" :key="iii">
                                    {{ e }}
                                </li>
                                <li class="list-group-item px-50 py-25 text-nowrap text-success" v-if="(r.Errors || []).length == 0">
                                    Hesaplama başarılı.
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        detail:Object
    }
}
</script>